import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import icon1 from "../../../assets/icon-1.svg";
import icon2 from "../../../assets/icon-2.svg";
import icon3 from "../../../assets/icon-3.svg";
import viconleft from "../../../assets/video-icon-left.svg";
import viconright from "../../../assets/video-icon-right.svg";
import Image from "mui-image";
import { Link } from "react-router-dom";

const Gurantee = () => {
  return (
    <section id="gurantee">
      <Container
        maxWidth="lg"
        sx={{ padding: { xs: "40px 0", sm: "40px 0", md: "130px 0 70px" } }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={8} sx={{ padding: "0 28px" }}>
            <Grid
              item
              xs={12}
              md={7}
              className="youtubGrid"
              sx={{
                position: "relative",
                paddingTop: { xs: "0px!important", sm: "0px!important" },
              }}
            >
              <Image
                className="videoIconLeft"
                src={viconleft}
                width={"58px"}
                height={"56px"}
              />

              <iframe
                width="100%"
                height="380"
                src="https://www.youtube.com/embed/Rsk2-XQhCAk?&autoplay=1"
                srcDoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{text-align:center;font:48px/1.5 sans-serif;color:white; width: 70px;
                height: 70px;
                margin: 0px auto;
                transform: translateY(-50%);
                background-color: #ef5366;
                position: absolute;
                left: 0px;
                right: 0px;
                top: 50%;
                border-radius: 50%;
                border: 0px;
                outline: none;
                box-shadow: inherit;
                cursor: pointer;
                transition: all 0.5s ease-in-out 0s;}span:hover{background-color: #ffffff; color:#ef5366}</style><a href=https://www.youtube.com/embed/Rsk2-XQhCAk?&autoplay=1><img src=https://i.ibb.co/0Xjd9h5/poster-img.webp alt='Video The Dark Knight Rises: What Went Wrong? – Wisecrack Edition'><span className=icon-resume>▶</span></a>"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="The Dark Knight Rises: What Went Wrong? – Wisecrack Edition"
              ></iframe>
              <Image
                className="videoIconRight"
                src={viconright}
                width={"58px"}
                height={"56px"}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={5}
              sx={{ paddingTop: { xs: "0px!important", sm: "64px" } }}
            >
              <Typography variant="h3" gutterBottom sx={{ mb: 5 }}>
                Simform <span className="highlight-head">Guarantee</span>
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={1} md={1}>
                  <Image src={icon1} width={"43px"} height={"43px"} />
                </Grid>
                <Grid item xs={11} md={11}>
                  <Typography variant="h6" sx={{ paddingLeft: "20px" }}>
                    Flexible, efficient scaling
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="p"
                    gutterBottom
                    align="left"
                    sx={{ paddingLeft: "20px", mb: 4 }}
                  >
                    Expand or reduce your remote team size on demand.
                  </Typography>
                </Grid>
                <Grid item xs={1} md={1}>
                  <Image src={icon2} width={"43px"} height={"43px"} />
                </Grid>
                <Grid item xs={11} md={11}>
                  <Typography variant="h6" sx={{ paddingLeft: "20px" }}>
                    Team of 1,000+ engineers
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="p"
                    gutterBottom
                    align="left"
                    sx={{ paddingLeft: "20px", mb: 4 }}
                  >
                    Access vetted experts in the tech stack of your choice.
                  </Typography>
                </Grid>
                <Grid item xs={1} md={1}>
                  <Image src={icon3} width={"43px"} height={"43px"} />
                </Grid>
                <Grid item xs={11} md={11}>
                  <Typography variant="h6" sx={{ paddingLeft: "20px" }}>
                    Long-term predictability
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="p"
                    gutterBottom
                    align="left"
                    sx={{ paddingLeft: "20px", mb: 4 }}
                  >
                    Simform’s average engagement duration is 2 years.
                  </Typography>
                </Grid>
                <Box
                  sx={{
                    textAlign: { xs: "center", sm: "center", md: "left" },
                    mb: 3.7,
                  }}
                >
                  <Link to="/contact" style={{ textDecoration: "none" }}>
                    <div className="button_slide_cmn slide_down_cmn">
                      Work with us{" "}
                    </div>
                  </Link>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </section>
  );
};

export default Gurantee;
